import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { mediaUrl } from "@/lib/api";
import api from "@/lib/api";
import { useLang } from "@/context/LangContext";
import PageHeader from "@/components/PageHeader";
import EmptyState from "@/components/EmptyState";

export default function Shop() {
  const { t } = useLang();
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/products").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="shop-page">
      <PageHeader eyebrow={t("nav_shop")} title={t("shop_title")} desc={t("shop_desc")} />
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-16 pb-24">
        {items === null ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">{[...Array(3)].map((_, i) => <div key={i} className="aspect-[3/4] rounded-xl bg-[#FFFFFF] animate-pulse" />)}</div>
        ) : items.length === 0 ? (
          <EmptyState title={t("empty_title")} desc={t("empty_desc")} />
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {items.map((p, i) => (
              <motion.div key={p.id} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }} transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}>
                <Link to={`/shop/${p.id}`} data-testid={`product-card-${p.id}`} className="hover-lift group block">
                  <div className="aspect-[3/4] rounded-2xl bg-[#F3E8E2] overflow-hidden border border-[rgba(61,50,56,0.08)]">
                    {p.cover_path ? <img src={mediaUrl(p.cover_path)} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                      : <div className="w-full h-full flex items-center justify-center font-serif text-5xl text-[rgba(198,137,158,0.2)]">{p.title.charAt(0)}</div>}
                  </div>
                  <div className="pt-4 flex items-start justify-between gap-4">
                    <h3 className="font-serif text-xl group-hover:text-[#C6899E] transition-colors">{p.title}</h3>
                    <span className="text-[#C6899E] font-serif text-xl shrink-0">{p.price > 0 ? `€${p.price}` : t("price_free")}</span>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
